<template>
  <!--左侧导航-->
  <aside :class="{showSidebar:!collapsed}" class="leftNavBar">
    <!--导航菜单-->
    <el-menu router :collapse="collapsed" ref="leftNavigation" :default-active="$route.path" class="navBox" unique-opened>
      <template v-for="item in leftNavList">
        <el-submenu v-if="item.children.length > 0 && item.children[0].menuType !== 3" :index="item.id.toString()" :key="item.id" :show-timeout="100">
          <template slot="title">
            <i class='iconfont' :class="item.menuPicCode"></i>
            <span>{{item.menuName}}</span>
          </template>
          <el-menu-item
            v-for="term in item.children"
            :key="term.id"
            :index="term.menuUrl">
            <span slot="title">{{term.menuName}}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item
          v-else
          :index="item.menuUrl"
          :key="item.id">
          <i class='iconfont' :class="item.menuPicCode"></i>
          <span slot="title">{{item.menuName}}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </aside>
</template>
<script>
// import { setTimeout } from 'timers'
export default {
  name: 'leftNav',
  props: {
    leftNavList: {
      type: Array
    },
    currentNav: {
      type: String
    },
    collapsed: {
      type: Boolean
    }
  },
  // beforeRouteUpdate (to, from, next) {
  //   console.log(1234556)
  //   console.log(to)
  // },
  data () {
    return {

    }
  },
  // watch: {
  //   $route: function (to, from) {
  //     let _this = this
  //     setTimeout(() => {
  //       _this.defaultLeftNavOpened()
  //     }, 500)
  //   }
  // },
  watch: {
    // leftNavList: {
    //   handler (val, oldVal) {
    //     this.$nextTick(() => {
    //       this.defaultLeftNavOpened()
    //     })
    //     // setTimeout(() => {
    //     //   this.defaultLeftNavOpened()
    //     // }, 100)
    //   },
    //   // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
    //   immediate: true,
    //   deep: true
    // },
    // $route: function (to, from) {
    //   if (to.query.isJump && to.path === '/personnel/employeeRelations/resignationManagement') {
    //     this.$nextTick(() => {
    //       this.defaultLeftNavOpened()
    //     })
    //   }
    // }
  },
  mounted () {
    // this.defaultLeftNavOpened()
  },
  methods: {
    // 左侧导航栏根据当前路径默认打开子菜单（如果当前是二级菜单，则父级子菜单默认打开）
    // defaultLeftNavOpened () {
    //   let curpath = this.$route.path // 获取当前路由
    //   let routers = this.leftNavList // 获取当前菜单树
    //   let subMenuIndex = ''
    //   for (let i = 0; i < routers.length; i++) {
    //     let children = routers[i].children
    //     if (children.length > 0) {
    //       for (let j = 0; j < children.length; j++) {
    //         if (children[j].menuUrl === curpath) {
    //           subMenuIndex = routers[i].id.toString()
    //         }
    //       }
    //     }
    //   }
    //   // console.log('最终')
    //   if (this.$refs['leftNavigation'] && subMenuIndex) {
    //     setTimeout(() => {
    //       this.$refs['leftNavigation'].open(subMenuIndex) // 打开子菜单
    //     }, 100)
    //   }
    // }
  }
}
</script>

<style lang="scss">
.leftNavBar{
  .el-icon-arrow-down:before{font-weight: bold;}
  position: relative;
}

</style>



// WEBPACK FOOTER //
// src/components/leftNav.vue